import React, { useRef, useState, useEffect, ReactNode } from 'react'
import { OverlayInjectedProps } from 'react-bootstrap/Overlay'
import BootstrapTooltip from 'react-bootstrap/Tooltip'
import { OverlayTrigger } from 'react-bootstrap'
import './OverflowTooltip.scss'
export const OverflowTooltip: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const [isOverflowed, setIsOverflowed] = useState(false)
  const [show, setShow] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)
  const childRef = useRef<HTMLElement | null>(null)
  const handleOnMouseEnter = () => {
    if (isOverflowed) {
      setShow(true)
    }
  }
  const handleOnMouseLeave = () => {
    if (isOverflowed) {
      setShow(false)
    }
  }

  useEffect(() => {
    if (!wrapperRef.current) {
      return
    }

    const findFirstOverflowedElement = () => {
      const wrapper = wrapperRef.current
      if (!wrapper) {
        return null
      }

      const isElementOverflowed = (element: HTMLElement): boolean => {
        const parent = element.parentElement
        return !!parent && element.scrollWidth > parent.clientWidth
      }

      const findOverflowedElement = (element: Element): HTMLElement | null => {
        for (let i = 0; i < element.children.length; i++) {
          const child = element.children[i] as HTMLElement
          if (!child.textContent?.trim()) continue
          if (isElementOverflowed(child)) {
            return child
          }
          const overflowNested = findOverflowedElement(child)
          if (overflowNested) {
            return overflowNested
          }
        }
        return null
      }

      if (isElementOverflowed(wrapper)) {
        return wrapper
      }

      return findOverflowedElement(wrapper)
    }
    const overflowedElement = findFirstOverflowedElement()
    childRef.current = overflowedElement

    if (overflowedElement) {
      setIsOverflowed(true)
    }
  }, [children])

  const renderTooltip = (props: OverlayInjectedProps) => (
    <BootstrapTooltip className='overflow-tooltip' {...props} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
      <div>{children}</div>
    </BootstrapTooltip>
  )

  return (
    <OverlayTrigger placement='top' show={show} overlay={renderTooltip}>
      <div
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
        ref={wrapperRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {children}
      </div>
    </OverlayTrigger>
  )
}
